import {
  FormControl,
  FormHelperText,
  OutlinedInput,
  TextField
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import { makeStyles } from "@saleor/macaw-ui";
import cls from "classnames";
import React, { useEffect, useState } from "react";

import MyTypography from "../MyTypography";
import { ISelectFieldProps } from "../SingleSelectField";

interface SingleFieldProps extends ISelectFieldProps {
  value?: string;
  isReset?: boolean;
  multiline?: boolean;
  size?: Partial<32 | 40 | 48 | 56>;
  className?: string;
  readOnly?: boolean;
  required?: boolean;
  labelFocus?: string;
  maxLengthProps?: number;
  regex?: RegExp;
  clearAble?: boolean;
  numberLimit?: number;

  onKeyPress?(event: any);

  onMouseEnter?(event: any);
}

const useStyles = makeStyles(
  theme => ({
    error: {
      color: theme.palette.error.main
    },
    root: {
      width: "100%",
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: "1rem",
        "& .MuiSvgIcon-root": {
          color: theme.palette.grey[500],
          cursor: "pointer"
        }
      }
    }
  }),
  { name: "SingleTextField" }
);
export const SingleTextField: React.FC<SingleFieldProps> = props => {
  const {
    disabled,
    label,
    value,
    onChange,
    onBlur,
    onKeyPress,
    name,
    hint,
    placeholder,
    error,
    multiline,
    className,
    readOnly,
    required,
    labelFocus,
    regex,
    maxLengthProps = 255,
    onMouseEnter,
    clearAble,
    numberLimit,
    id,
    InputProps
  } = props;
  const classes = useStyles();
  const [textValue, setValue] = useState(value);

  const handleChange = event => {
    const value = event.target.value;
    if (
      value &&
      regex &&
      (!regex.test(value) || value.length > maxLengthProps)
    ) {
      return;
    }
    if (numberLimit) {
      if (Number(value) > numberLimit) {
        return;
      }
    }
    if (value.length <= maxLengthProps) {
      setValue(value);
    }
  };

  const clearValue = () => {
    setValue("");
  };

  useEffect(() => {
    onChange({
      target: {
        name,
        value: textValue
      }
    });
  }, [textValue]);

  useEffect(() => {
    setValue(value);
  }, [value]);

  return (
    <FormControl className={classes.root} error={error} disabled={disabled}>
      {label ? (
        <MyTypography variant="body3">
          {label} {required ? <span className={classes.error}>*</span> : ""}
        </MyTypography>
      ) : null}
      {!labelFocus ? (
        <OutlinedInput
          aria-describedby="outlined-weight-helper-text"
          autoComplete="off"
          error={error}
          value={textValue}
          name={name}
          onMouseEnter={onMouseEnter}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur}
          onKeyDown={onKeyPress}
          multiline={multiline}
          readOnly={readOnly}
          className={cls(className)}
          endAdornment={
            clearAble && value ? <CloseOutlined onClick={clearValue} /> : ""
          }
          id={id}
          inputProps={{
            ...InputProps?.inputProps
          }}
        />
      ) : (
        <TextField
          aria-describedby="outlined-weight-helper-text"
          autoComplete="off"
          error={error}
          value={value}
          name={name}
          onMouseEnter={onMouseEnter}
          label={labelFocus}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur}
          onKeyDown={onKeyPress}
          multiline={multiline}
          className={cls(className)}
          inputProps={{
            maxLength: maxLengthProps,
            ...InputProps?.inputProps
          }}
          id={id}
        />
      )}
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </FormControl>
  );
};
export default SingleTextField;
